import React, { useState } from "react";
import Login from "./Login";
import SignUp from "./SignUp";

export default function AuthForms() {
  // false = Login Mode, true = Signup Mode
  const [isSignUp, setIsSignUp] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      {/* Main Card Container */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl min-h-[500px] md:min-h-[600px] overflow-hidden flex flex-col md:block">

        {/* 
            FORM SECTION: LOGIN (Left Side on Desktop)
            - Visible when Login Mode is ACTIVE (!isSignUp)
            - On Desktop: Always 'there' but covered by overlay if inactive.
            - To prevent interaction when covered, we can toggle z-index or visibility.
        */}
        <div className={`
            w-full h-full flex flex-col justify-center bg-white transition-all duration-700 z-20
            md:absolute md:top-0 md:left-0 md:w-1/2
            ${isSignUp ? 'hidden md:flex md:opacity-0 pointer-events-none' : 'flex md:opacity-100 pointer-events-auto'}
        `}>
          <Login />

          {/* Mobile Only Switch Link */}
          <div className="md:hidden text-center pb-8">
            <p className="text-gray-500 text-sm">
              New here? <button type="button" onClick={() => setIsSignUp(true)} className="text-blue-600 font-bold hover:underline">Sign Up</button>
            </p>
          </div>
        </div>

        {/* 
            FORM SECTION: SIGNUP (Right Side on Desktop)
            - Visible when Signup Mode is ACTIVE (isSignUp)
        */}
        <div className={`
            w-full h-full flex flex-col justify-center bg-white transition-all duration-700 z-20
            md:absolute md:top-0 md:right-0 md:w-1/2
            ${isSignUp ? 'flex md:opacity-100 pointer-events-auto' : 'hidden md:flex md:opacity-0 pointer-events-none'}
        `}>
          <SignUp />

          {/* Mobile Only Switch Link */}
          <div className="md:hidden text-center pb-8">
            <p className="text-gray-500 text-sm">
              Already have an account? <button type="button" onClick={() => setIsSignUp(false)} className="text-green-600 font-bold hover:underline">Sign In</button>
            </p>
          </div>
        </div>

        {/* 
            OVERLAY SECTION (The Slider) - DESKTOP ONLY
            - Covers the INACTIVE side.
            - LOGIN ACTIVE (!isSignUp): Overlay should be on RIGHT (blocking Signup).
            - SIGNUP ACTIVE (isSignUp): Overlay should be on LEFT (blocking Login).
        */}
        <div
          className={`hidden md:block absolute top-0 left-0 h-full w-1/2 z-40 transition-transform duration-700 ease-in-out ${isSignUp ? "translate-x-0" : "translate-x-full"
            }`}
        >
          <div className="h-full w-full relative overflow-hidden text-white">
            {/* Gradient Background */}
            <div
              className={`absolute inset-0 transition-colors duration-700 ${isSignUp
                ? "bg-gradient-to-br from-teal-400 to-green-600"
                : "bg-gradient-to-br from-blue-500 to-purple-600"
                }`}
            ></div>

            {/* Decorative Blobs */}
            <div className="absolute top-[-20%] left-[-20%] w-64 h-64 bg-white/20 rounded-full blur-3xl animate-blob"></div>
            <div className="absolute bottom-[-20%] right-[-20%] w-64 h-64 bg-white/20 rounded-full blur-3xl animate-blob animation-delay-2000"></div>

            {/* Overlay Content */}
            <div className="relative h-full flex flex-col items-center justify-center text-center p-12">

              {/* 
                  SCENARIO: LOGIN is ACTIVE (Right side covered).
                  Overlay is on the RIGHT.
                  Text should prompt user to go to Signup.
               */}
              <div
                className={`absolute transition-opacity duration-700 ${!isSignUp ? "opacity-100 delay-100" : "opacity-0 pointer-events-none"
                  }`}
              >
                <h2 className="text-3xl font-bold mb-4">New Here?</h2>
                <p className="mb-8 text-blue-50">Sign up and discover a new world of chatting.</p>
                <button
                  type="button"
                  onClick={() => setIsSignUp(true)}
                  className="border-2 border-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-600 transition-all transform hover:scale-105"
                >
                  Sign Up
                </button>
              </div>

              {/* 
                  SCENARIO: SIGNUP is ACTIVE (Left side covered).
                  Overlay is on the LEFT.
                  Text should prompt user to go to Login.
               */}
              <div
                className={`absolute transition-opacity duration-700 ${isSignUp ? "opacity-100 delay-100" : "opacity-0 pointer-events-none"
                  }`}
              >
                <h2 className="text-3xl font-bold mb-4">Welcome Back!</h2>
                <p className="mb-8 text-green-50 m-2">To keep connected with your love ones please login with your personal info.</p>
                <button
                  type="button"
                  onClick={() => setIsSignUp(false)}
                  className="border-2 border-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-green-600 transition-all transform hover:scale-105"
                >
                  Sign In
                </button>
              </div>

            </div>
          </div>
        </div>

      </div>
      <p className="fixed bottom-4 text-gray-400 text-xs">Version v3.6</p>
    </div>
  );
}
